import { redactSensitiveFields, redactString } from './sentry-sanitization';

/**
 * Check if running in local/development environment
 */
const isLocalDev = () => {
  return (
    process.env.NODE_ENV === 'development' ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('localhost')
  );
};

/**
 * Sanitize log arguments before logging
 */
const sanitizeArgs = (...args) => {
  return args.map(arg => {
    if (typeof arg === 'object' && arg !== null) {
      return redactSensitiveFields(arg);
    }
    if (typeof arg === 'string') {
      return redactString(arg);
    }
    return arg;
  });
};

/**
 * Custom logger that sanitizes in production/staging
 * In local/dev, logs unsanitized for debugging
 */
class Logger {
  log(...args) {
    if (isLocalDev()) {
      console.log(...args);
    } else {
      console.log(...sanitizeArgs(...args));
    }
  }

  error(...args) {
    if (isLocalDev()) {
      console.error(...args);
    } else {
      console.error(...sanitizeArgs(...args));
    }
  }

  warn(...args) {
    if (isLocalDev()) {
      console.warn(...args);
    } else {
      console.warn(...sanitizeArgs(...args));
    }
  }

  info(...args) {
    if (isLocalDev()) {
      console.info(...args);
    } else {
      console.info(...sanitizeArgs(...args));
    }
  }

  debug(...args) {
    if (isLocalDev()) {
      console.debug(...args);
    }
    // In production, debug logs are completely suppressed
  }
}

export const logger = new Logger();
export default logger;
